export { default as IconText } from './icon-text';
